// extracted by mini-css-extract-plugin
export default {"link":"other_link__Lm1-Q","next":"other_next__4wIFe"};